import React from "react";
import { Formik, Form, Field } from "formik";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import axiosForgetPasswordInstance from "../axios/AxiosForget";
import * as Yup from "yup";
import Swal from "sweetalert2";
import "animate.css";

const validationSchema = Yup.object({
  email: Yup.string().email("Invalid Email").required("Email Required"),
});

export default function ForgetPassword() {
  const Navigate = useNavigate();

  const initialValues = {
    email: "",
    redirect_url: "http://localhost:3000/new-password/",
  };
  const onSubmit = (values, onSubmitProps) => {
    console.log("Form Data", values);
    axiosForgetPasswordInstance
      .post("/users/password_reset/", values)
      .then((res) => {
        Navigate("/login");
        console.log(res.data);
        Swal.fire({
          title: "Verification Required",
          text: "We have sent you a link to reset your password",
          icon: "info",
          timer: 3000,
          showConfirmButton: false,
          showClass: {
            popup: "animate__animated animate__fadeInDown",  
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        });
      })
      .catch((err) => {
        console.log("error", err);
        onSubmitProps.setSubmitting(false);
        Swal.fire({
          title: "Oops...",
          text: "Something went wrong try again",
          icon: "warning",
          timer: 3000,
          showConfirmButton: false,
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        });
      });
  };
  return (
    <>
      <div className="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div>
            <h2 className="mt-32 text-left font-Montserrat text-2xl font-bold text-black">
              Enter e-mail address
            </h2>
            <div className="border-b-2 border-blue-200 w-24"></div>
          </div>
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            validateOnMount
          >
            <Form className="mt-8 space-y-6" action="#" method="POST">
              <Field name="email">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                      <input
                        {...field}
                        type="text"
                        {...(meta.touched && meta.error
                          ? {
                              className:
                                "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                            }
                          : {
                              className:
                                "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                            })}
                        placeholder="Email"
                      ></input>
                      {meta.touched && meta.error ? (
                        <label className="text-xs font-semibold font-Montserrat text-red-500">
                          <span className="ml-1">{meta.error}</span>
                        </label>
                      ) : null}
                    </>
                  );
                }}
              </Field>
              <Field>
                {(props) => {
                  const { field, form, meta } = props;
                  const { isSubmitting } = form;
                  return (
                    <>
                      {!isSubmitting ? (
                        <button
                          type="submit"
                          {...(form.isValid
                            ? {
                                className:
                                  "font-Montserrat font-semibold text-white flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow ",
                              }
                            : {
                                disabled: true,
                                className:
                                  "font-Montserrat font-semibold text-white flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow opacity-50 cursor-not-allowed",
                              })}
                        >
                          Confirm
                        </button>
                      ) : (
                        <button
                          disabled
                          className="font-Montserrat font-semibold flex-shrink bg-blue-200 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow"
                        >
                          <div className="flex items-center justify-center space-x-2 animate-pulse">
                            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                          </div>
                        </button>
                      )}
                    </>
                  );
                }}
              </Field>
            </Form>
          </Formik>
        </div>
      </div>
    </>
  );
}
